import axios from 'axios'
import Cookies from 'universal-cookie'
import {
    isNumber
} from 'util';

import {
    API_URL
} from './constants'
import Immutable, {
    isImmutable
} from 'immutable';

const cookies = new Cookies()

export function createAxiosInstance(config) {
    const token = cookies.get('token')
    if (!token) return null
    let minConfig = {
        baseURL: API_URL,
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }
    if (config) {
        if (config.headers) {
            minConfig.headers = {
                ...minConfig.headers,
                ...config.headers
            }
        } else {
            minConfig = {
                ...minConfig,
                ...config
            }
        }
    }

    return axios.create(minConfig)
}

export function guid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
}

export const uniqueArray = (arr) => [...new Set(arr)]

export function proximoCampoDisponible(configuraciones) {
    let campo = 0
    configuraciones.some((x, n) => {
        if (x.get('campo') !== (n + 1)) campo = (n + 1)
        return campo !== 0
    })
    if (campo === 0) campo = configuraciones.count() + 1

    return campo
}

export function transformParameterData(parametro) {
    const columnas = []
    const table = parametro.get('configuraciones').valueSeq().reduce((a, b) => {
        if (columnas.filter(c => c.nombre === b.get('nombre')).length === 0) {
            columnas.push({
                id: b.get('id'),
                posicion: b.get('posicion'),
                caption: b.get('nombre').replace(/_/g, ' '),
                value: b.get('nombre'),
                type: 'string',
                format: '',
                parametro_id: parametro.get('id'),
                config_parametro_id: b.get('id')
            })
        }
        b.get('detalles').valueSeq().forEach(x => {
            if (!a[x.get('registro')]) a[x.get('registro')] = {}
            a[x.get('registro')].registro = x.get('registro')
            a[x.get('registro')][b.get('id')] = {
                id: x.get('id'),
                valor: x.get('valor'),
                updated: false,
                guid: guid(),
                parametro_id: parametro.get('id'),
                config_parametro_id: b.get('id'),
                created_at: x.get('created_at')
            }
        })
        return a
    }, {})

    const data = {}
    for (let key in table) {
        if (table.hasOwnProperty(key)) {
            const obj = columnas.reduce((a, b) => {
                a[b.id] = {
                    id: null,
                    valor: null,
                    updated: false,
                    guid: guid(),
                    parametro_id: parametro.get('id'),
                    config_parametro_id: b.config_parametro_id
                }
                a.selected = false
                a.deleted = false
                return a
            }, {})
            data[key] = {
                ...obj,
                ...table[key]
            }
        }
    }

    return {
        columnas,
        data
    }
}

export function validateModel(model, rules, context = null) {
    if (!isImmutable(model)) model = Immutable.fromJS(model)
    const errors = []
    rules.forEach(x => {
        const key = x.key
        let max, min
        let modelValue = model.getIn(key.split('.'))
        const conditions = x.conditions.split('|').map(y => y.trim())
        conditions.forEach(y => {
            switch (true) {
                case y === 'required':
                    if (modelValue === "" || modelValue === undefined || modelValue === null) errors.push({
                        key,
                        message: `El campo ${key.replace(/_/g,' ')} es requerido`
                    })
                    break;
                case y === 'number':
                case y === 'numeric':
                    modelValue = Number(modelValue)
                    if (typeof modelValue !== 'number') errors.push({
                        key,
                        message: `El campo ${key.replace(/_/g,' ')} debe ser una valor numérico`
                    })
                    break;
                case y.startsWith('max:'):
                    max = Number(y.split(':')[1])
                    modelValue = Number(modelValue)
                    if (modelValue > max) {
                        errors.push({
                            key,
                            message: `El campo ${key.replace(/_/g,' ')} no puede ser superior a ${max}`
                        })
                    }
                    break
                case y.startsWith('min:'):
                    min = Number(y.split(':')[1])
                    modelValue = Number(modelValue)
                    if (modelValue < min) {
                        errors.push({
                            key,
                            message: `El campo ${key.replace(/_/g,' ')} no puede ser inferior a ${min}`
                        })
                    }
                    break
                case y.startsWith('unique'):
                    const path = y.split(':')[1]
                    if (context.getIn(path.split('.')).valueSeq().some(x => x.getIn([key, 'id']) === modelValue.get('id'))) {
                        errors.push({
                            key,
                            message: `El campo ${key.replace(/_/g,' ')} debe ser único`
                        })
                    }
                    break
            }
        })
    })
    return errors;
}